// The A1 "First words" starter set — ~36 essential phrases a brand-new learner
// can pick up on day one, before they've generated anything from sentence
// practice. Hand-picked (no AI), grouped loosely greeting → courtesy → meeting
// people → survival. Used by the Starter view (src/views/starter.js).
export const STARTER_PHRASES = [
  { es: "Hola", en: "Hello" },
  { es: "Buenos días", en: "Good morning" },
  { es: "Buenas tardes", en: "Good afternoon" },
  { es: "Buenas noches", en: "Good evening / Good night" },
  { es: "Adiós", en: "Goodbye" },
  { es: "Hasta luego", en: "See you later" },
  { es: "Hasta mañana", en: "See you tomorrow" },

  { es: "Por favor", en: "Please" },
  { es: "Gracias", en: "Thank you" },
  { es: "Muchas gracias", en: "Thank you very much" },
  { es: "De nada", en: "You're welcome" },
  { es: "Perdón", en: "Sorry / Excuse me" },
  { es: "Lo siento", en: "I'm sorry" },
  { es: "Con permiso", en: "Excuse me (to get past)" },

  { es: "¿Cómo estás?", en: "How are you? (informal)" },
  { es: "¿Cómo está usted?", en: "How are you? (formal)" },
  { es: "Bien, gracias", en: "Fine, thanks" },
  { es: "Más o menos", en: "So-so" },
  { es: "¿Y tú?", en: "And you?" },

  { es: "Me llamo…", en: "My name is…" },
  { es: "¿Cómo te llamas?", en: "What's your name?" },
  { es: "Mucho gusto", en: "Nice to meet you" },
  { es: "Soy de…", en: "I'm from…" },
  { es: "¿De dónde eres?", en: "Where are you from?" },

  { es: "Sí", en: "Yes" },
  { es: "No", en: "No" },
  { es: "No sé", en: "I don't know" },
  { es: "No entiendo", en: "I don't understand" },
  { es: "¿Hablas inglés?", en: "Do you speak English?" },
  { es: "¿Puedes repetir, por favor?", en: "Can you repeat, please?" },
  { es: "Más despacio, por favor", en: "Slower, please" },
  { es: "¿Cómo se dice…?", en: "How do you say…?" },
  { es: "¿Qué significa…?", en: "What does … mean?" },
  { es: "¿Cuánto cuesta?", en: "How much is it?" },
  { es: "¿Dónde está el baño?", en: "Where is the bathroom?" },
  { es: "Ayuda, por favor", en: "Help, please" },
];
